import { useEffect, useRef, useState } from "react";

import { useEmojiCanvasImages } from "./useEmojiCanvasImages.js";

export type EmojiCanvasImgProps = {
  emojis: string[];
  color1: string;
  // color2: string;
  width: number;
  height: number;
  rotationAngle?: number;
  animationInterval?: number;
  animationTrigger?: "ALWAYS" | "HOVER";
  isHovered: boolean;
  isAnimationEnabled?: boolean;
  // animation?: "off" | "rotate";
  shouldCache?: boolean;
};
function getShouldAnimate({
  isHovered,
  isAnimationEnabled,
  animationTrigger,
}: {
  isHovered: boolean;
  isAnimationEnabled: boolean;
  animationTrigger: "ALWAYS" | "HOVER";
}) {
  if (!isAnimationEnabled) return false;

  if (animationTrigger === "ALWAYS") return true;

  if (animationTrigger === "HOVER") return isHovered;
}
export const EmojiCanvasImg = ({
  emojis,
  color1,
  // color2,
  width,
  height,
  rotationAngle: _rotationAngle = 45,
  animationInterval = 700,
  isAnimationEnabled = true,
  isHovered,
  animationTrigger = "HOVER",
  shouldCache,
}: EmojiCanvasImgProps) => {
  const canvasRef = useRef(null);
  // const [rotationAngle, setRotationAngle] = useState(_rotationAngle);
  const [rotationAngle, setRotationAngle] = useState(_rotationAngle);

  const [rotationAngles] = useState([_rotationAngle, _rotationAngle + 25]);

  const { imgMap, isReady } = useEmojiCanvasImages({
    emojis,
    color1,
    // color2,
    width,
    height,
    rotationAngles,
    animationInterval,
    shouldCache,
    emojiSize: 17,
    emojiGapSize: 14,
  });

  const shouldAnimate = getShouldAnimate({
    isHovered,
    isAnimationEnabled,
    animationTrigger,
  });

  useEffect(() => {
    setRotationAngle(_rotationAngle);
  }, [_rotationAngle]);

  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    if (!canvasRef.current) return;

    // check prefers-reduced-motion
    const mediaQueryList = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    );
    if (mediaQueryList.matches) {
      console.log("Reduced motion is enabled, stopping animation");
      setPrefersReducedMotion(true);
    }
  }, []);

  useEffect(() => {
    if (prefersReducedMotion) return;
    if (!shouldAnimate) return;

    const minimumInterval = 100;
    const intervalTime = Math.max(animationInterval, minimumInterval);

    const interval = setInterval(() => {
      setRotationAngle((prevAngle) =>
        prevAngle === _rotationAngle ? _rotationAngle + 25 : _rotationAngle
      );
    }, intervalTime);

    return () => {
      clearInterval(interval);
    };
  }, [
    animationInterval,
    rotationAngle,
    rotationAngles,
    _rotationAngle,
    shouldAnimate,
    prefersReducedMotion,
  ]);

  const bgImage = `url(${imgMap?.[rotationAngle.toString()]})`;

  return (
    <div
      data-supabanner-emoji-canvas
      style={{
        display: "block",
        backgroundColor: color1,
        width: "100%",
        position: "absolute",
        inset: 0,
        content: "",
      }}
    >
      <div
        style={{
          display: "block",
          backgroundImage: bgImage,
          backgroundPositionY: "center",
          backgroundPositionX: "center",
          position: "absolute",
          // zIndex: 10,
          inset: 0,
          transitionProperty: "opacity",
          transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
          transitionDuration: "550ms",
          opacity: isReady ? 1 : 0,
        }}
      ></div>
    </div>
  );
};
